import { inferRouterInputs } from '@trpc/server';
import { AppRouter } from '../../../back/app.ts';
import { getCriticalValuesMissing } from '../../services/getCriticalValuesMissing.ts';
import { Protocol, RecordDraft } from '../../types/sharedTypeImpl.ts';
import { draftToRecord } from '../../utils/conversion.ts';
import { getNumOutOfSpec } from '../../utils/getNumOutOfSpec.ts';


type RouterInputs = inferRouterInputs<AppRouter>;
type UpsertRecordInput = RouterInputs['records']['upsert'];

export function finalizeRecord(record: RecordDraft, protocol: Protocol): UpsertRecordInput {
    const numOutOfSpec = getNumOutOfSpec(record, protocol);
    const criticalValuesMissing = getCriticalValuesMissing(record, protocol);
    const recordFinal = draftToRecord(record, numOutOfSpec, criticalValuesMissing);
    return recordFinal;
}
